import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, BadgeCheck, MessageSquareMore } from 'lucide-react';
import { trustFeatures } from '../data/mock';

const iconMap = {
  ShieldCheck: ShieldCheck,
  BadgeCheck: BadgeCheck,
  MessageSquareMore: MessageSquareMore,
};

const TrustSection = () => {
  return (
    <section
      id="trust"
      className="section-padding"
      style={{ background: 'var(--bg-section)' }}
    >
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span
              className="inline-block px-4 py-1.5 rounded-full text-sm font-medium mb-4"
              style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}
            >
              Trust & Safety
            </span>
            <h2 className="heading-2 mb-4">Your safety is our priority</h2>
            <p className="body-large max-w-2xl mx-auto">
              We've built multiple layers of verification and protection to ensure every
              interaction on Crew Up is safe and professional.
            </p>
          </motion.div>
        </div>

        {/* Trust Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {trustFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
              >
                <div className="feature-card h-full text-center">
                  {/* Icon */}
                  <div
                    className="w-16 h-16 rounded-2xl mx-auto mb-6 flex items-center justify-center"
                    style={{ background: 'var(--accent-primary)' }}
                  >
                    <Icon size={32} style={{ color: 'var(--text-primary)' }} />
                  </div>

                  {/* Content */}
                  <h3 className="heading-3 mb-3">{feature.title}</h3>
                  <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Trust Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white border border-black/10 shadow-sm">
            <ShieldCheck size={20} style={{ color: 'var(--accent-text)' }} />
            <span className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
              All staff undergo comprehensive background verification
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;
